export default __webpack_public_path__ + "static/banner-how-to-live-within-your-means-c27a9dd613e6dfaf1bba731c2c7d43e6.jpg";